export default "__VITE_ASSET__7d773443__"